// src/components/StackedBarChart.js
import React from "react";
import { Bar } from "react-chartjs-2";

export function StackedBarChart({
  title,
  labels,
  yMax,
  datasets,
  yAxisTitle = "Investment (£ billions)",
  className = "w-full h-96 mt-4",
}) {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: { display: true, text: title, font: { size: 14 } },
      legend: { position: "bottom", labels: { usePointStyle: true, padding: 15 } },
      tooltip: {
        mode: "index",
        intersect: false,
        callbacks: {
          label: (ctx) => {
            const v = ctx.parsed.y;
            return `${ctx.dataset.label}: £${v?.toLocaleString?.() ?? v}B`;
          },
        },
      },
    },
    scales: {
      x: { stacked: true, grid: { display: false } },
      y: {
        stacked: true,
        beginAtZero: true,
        title: { display: true, text: yAxisTitle },
        // ticks: {
        //   callback: (value) => "£" + value + "B",
        // },
        max: yMax,
      },
    },
  };

  return (
    <div className={className}>
      <Bar data={{ labels, datasets }} options={options} />
    </div>
  );
}
